import { Box, Button, Container, Stack, Typography } from "@mui/material";
import { useParams, Navigate, Link as RouterLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

interface ServiceItem {
    title: string;
    description: string;
    slug: string;
    detailTitle?: string;
    detailParagraphs?: string[];
}

export default function ServiceDetail() {
    const { slug } = useParams<{ slug: string }>();
    const { t } = useTranslation();

    const services = t("servicesPage.items", { returnObjects: true }) as ServiceItem[];
    const service = services.find((s) => s.slug === slug);

    if (!service) {
        return <Navigate to="/leistungen" replace />;
    }

    return (
        <Box sx={{ py: { xs: 5, md: 8 } }}>
            <Container maxWidth="lg">
                <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>
                    <RouterLink to="/leistungen" style={{ color: "inherit", textDecoration: "none" }}>
                        &larr; Zurück zur Übersicht
                    </RouterLink>
                </Typography>

                <Stack direction={{ xs: "column", md: "row" }} spacing={6} alignItems="flex-start" sx={{ mb: 8 }}>
                    <Box sx={{ flex: 1 }}>
                        <Typography variant="h1" sx={{ mb: 4 }}>
                            {service.detailTitle || service.title}
                        </Typography>

                        <Stack spacing={3}>
                            {(service.detailParagraphs || [service.description]).map((paragraph: string, index: number) => (
                                <Typography key={index} variant="body1" sx={{ fontSize: "1.1rem", lineHeight: 1.8, color: "text.secondary" }}>
                                    {paragraph}
                                </Typography>
                            ))}
                        </Stack>
                    </Box>
                    <Box sx={{ flex: 1, width: "100%" }}>
                        <Box
                            component="img"
                            src={`/services/${service.slug}.png`}
                            alt={service.title}
                            sx={{
                                width: "100%",
                                height: "auto",
                                borderRadius: 4,
                                boxShadow: "0 20px 40px rgba(0,0,0,0.08)",
                                objectFit: "cover",
                            }}
                        />
                    </Box>
                </Stack>

                <Box sx={{ textAlign: "center", mt: 10, p: 6, backgroundColor: "var(--surface)", borderRadius: 4 }}>
                    <Typography variant="h3" sx={{ mb: 3 }}>
                        {t("servicesPage.cta.title")}
                    </Typography>
                    <Button component={RouterLink} to="/angebot" variant="contained" color="primary" size="large" sx={{ px: 6, py: 1.5 }}>
                        {t("servicesPage.cta.button")}
                    </Button>
                </Box>
            </Container>
        </Box>
    );
}
